import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';
import { TypedJourney } from "./journey.query";


export interface TypedAddress_suggestion {
    id?: string;
    address?: string;
    journey_id?: string | number | bigint;
    journey_from_id?: string;
    address_data?: string;
    createdAt?: string;

    journey?: TypedJourney
}


type IQuery = TypedAddress_suggestion & IQueryParams;


/*
* List of all app
*/
export function useGetAddressSuggestions(object?: IQuery) {
    return useQuery({
        queryKey: ["address_suggestion/fetch_entity_list", object],
        queryFn: () => axios.get<TypedAddress_suggestion[]>(`/address_suggestion${helpers.buildEndUrl(object)}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: !!object,
    });
}




/** Modal sẽ gọi vào đây, khoanh vùng quyền tại router này */
export function useMutateGetAddressSuggestions() {
    return useMutation({
        mutationKey: ['address_suggestion/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedAddress_suggestion[]>(`/address_suggestion/quick_suggest/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetAddressSuggestion() {
    return useMutation({
        mutationKey: ['address_suggestion/fetch_entity'],
        mutationFn: (address_suggestion_id: any) => axios.get<TypedAddress_suggestion>(`/address_suggestion/${address_suggestion_id}`).then((response) => response.data),
    });
}

export function useUpdateAddressSuggestion() {
    return useMutation({
        mutationKey: ['address_suggestion/update_entity'],
        mutationFn: ({ id, ...rest }: TypedAddress_suggestion) => axios.patch<TypedAddress_suggestion>(`/address_suggestion/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['address_suggestion/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['address_suggestion/fetch_entity'] });
        }
    });
}

export function useMutateCreateAddressSuggestion() {
    return useMutation({
        mutationKey: ['address_suggestion/create_entity'],
        mutationFn: (entity: TypedAddress_suggestion) => axios.post<TypedAddress_suggestion>(`/address_suggestion`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['address_suggestion/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteAddressSuggestion() {
    return useMutation({
        mutationKey: ['address_suggestion/delete_entity'],
        mutationFn: (id: any) => axios.delete<TypedAddress_suggestion>(`/address_suggestion/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['address_suggestion/fetch_entity_list'] });
        }
    });
}